import { selectAll } from "@fruugo/utilities";

export function initFooterAccordions() {
  const mq = window.matchMedia("(min-width: 1024px)");
  const details = selectAll<HTMLDetailsElement>(".js-footer-accordion");

  function updateAccordionMode() {
    const isDesktop = mq.matches;

    details.forEach((detail) => {
      const summary = detail.querySelector("summary");

      if (!summary) return;

      if (isDesktop) {
        // 1. Force open
        detail.open = true;

        // 2. Disable interaction
        summary.setAttribute("tabindex", "-1");
        summary.setAttribute("aria-disabled", "true");

        // 3. Prevent all toggling (mouse + keyboard)
        summary.addEventListener("click", preventToggle);
        summary.addEventListener("keydown", preventToggle);
      } else {
        detail.open = false;
        // Restore normal behavior
        summary.removeAttribute("tabindex");
        summary.removeAttribute("aria-disabled");

        summary.removeEventListener("click", preventToggle);
        summary.removeEventListener("keydown", preventToggle);
      }
    });
  }

  function preventToggle(e: Event) {
    e.preventDefault();
  }

  mq.addEventListener("change", updateAccordionMode);
  updateAccordionMode();
}
